<template>
  <div>
    <h1>{{ msg }}</h1>

    <Row type="flex" :gutter="24" justify="space-between" style="margin-top: 50px">
      <Col :xs="24" :sm="12" :md="8" :lg="6" v-for="item in buttons" :key="item.msg">
        <Card
          class="card-container"
          @click.native="$router.push({ name: item.view_name, query: item.params })">
          <img :src="item.img" alt="" class="background-img">
          <div class="">
            <h2 class="mb-30">{{ item.msg }}</h2>

            <span class="fs-16">
              {{ item.description }}
            </span>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
    // import topProductsChart from "./topProductsChart";
    // import averageOrderChart from "./averageOrderChart";
    // import revenueChart from "./revenueChart";
    // import paymentType from "./paymentType";

    export default {
        name: "productOrderActions",

        data() {
            return {
                msg: "Выберите действие:",
                buttons: [
                    {
                        msg: "Продажа",
                        description: "свободная продажа без кассового аппарата",
                        view_name: "product_order_create",
                        params: {type: "SELL"},
                        img: '/static/img/action_img/img-1.png'
                    },
                    {
                        msg: "Закупка",
                        description: "закупка товара у поставщика",
                        view_name: "product_order_create",
                        params: {type: "PURCHASE"},
                        img: '/static/img/action_img/img-2.png'
                    },
                    {
                        msg: "Возврат продажи",
                        description: "возврат товара от покупателя/возврат денег покупателю",
                        view_name: "product_order_create",
                        params: {type: "RETURN_SELL"},
                        img: '/static/img/action_img/img-3.png'
                    },
                    {
                        msg: "Возврат закупки",
                        description: "возврат товара поставщику/возврат денег от поставщика",
                        view_name: "product_order_create",
                        params: {type: "RETURN_PURCHASE"},
                        img: '/static/img/action_img/img-4.png'
                    },
                    {
                        msg: "Оприходование",
                        description: "добавление неучтенного товара",
                        view_name: "product_order_change_in_create",
                        params: {},
                        img: '/static/img/action_img/img-5.png'
                    },
                    {
                        msg: "Списание",
                        description: "изъятие/снятие/удаление товара с баланса",
                        view_name: "product_order_change_out_create",
                        params: {},
                        img: '/static/img/action_img/img-6.png'
                    },
                    {
                        msg: "Перемещение",
                        description: "перемещение собственного товара с одного объекта на другой",
                        view_name: "product_order_change_moving_create",
                        params: {},
                        img: '/static/img/action_img/img-7.png'
                    },
                    {
                        msg: "Инвентаризация",
                        description: "проверка наличия фактических остатков",
                        view_name: "product_order_inventory_create",
                        params: {},
                        img: '/static/img/action_img/img-8.png'
                    },
                ]
            };
        }
    };
</script>

<style scoped>
  .card-container {
    position: relative;
    background-color: #F1F1F1;
    text-align: left;
    padding: 24px;
    width: 100%;
    min-height: 225px;
    cursor: pointer;
    /*margin: 10px*/
    margin-bottom: 40px;
    border: none;
  }

  .card-container span {
    transition: 0.3s ease-in;
    padding-right: 30%;
    display: block;
  }

  .background-img {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .z-index-2 {
    position: relative;
    z-index: 2;
  }

  .card-container:hover {
    background-color: #1DBDC6;

  }

  .card-container:hover h2, .card-container:hover span {
    color: #ffffff
  }

  @media screen and (max-width: 1900px) {
    .card-container {
      min-height: 200px;
    }
  }

  @media screen and (max-width: 1500px) {
    .card-container {
      padding: 15px 0;
    }
  }

  @media screen and (max-width: 1365px) {
    .background-img {
      height: 70%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/product_order/productOrderActions.vue